import { AlertCircleIcon, AlertTriangleIcon } from '@balance-web/icon';

export const TONE_ICONS = {
  critical: AlertCircleIcon,
  cautious: AlertTriangleIcon,
  informative: AlertCircleIcon,
} as const;
